import css from "./style.module.css"; 
import AddEngineer from "../../Components/AddEngineer/AddEnterpriseEngineer";
import { useState, useEffect } from "react";
import { Put, Get } from "../../Services/Server";
import Url from "../../Services/Url";
import { toast } from "react-toastify";
import Button from "../../Components/Button/Button";
import Svg from "../../Components/Svg/Svg";
import SvgOptions from "../../Components/Svg/SvgOptions";

const AssignSurveyEngModal = ({ children }) => {
  const { surveyData, closeModal } = children;

  const [selectedEngineer, setSelectedEngineer] = useState(null);

  // Fetch existing engineer if surveyData.eng_id is present
  useEffect(() => {
    if (surveyData.eng_id) {
      Get(Url.staffById(surveyData.eng_id))
        .then((resp) => {
          setSelectedEngineer(resp); // backend returns staff object
        })
        .catch((err) => {
          console.error("Error fetching staff:", err);
        });
    }
  }, [surveyData.eng_id]);

  const onSubmit = (op) => {
    const engineer = op.Fields.find((f) => f.name === "engineer")?.value;
    setSelectedEngineer(engineer); // replace engineer
  };

  const handleDelete = () => {
    setSelectedEngineer(null);
  };

  const Save = () => {
    if (!selectedEngineer) {
      toast("Please select an engineer before saving.");
      return;
    }

    const updatedSurvey = {
      ...surveyData,
      eng_id: selectedEngineer.id,
      status: "ongoing"
    };

    Put(Url.survey.updateSurvey(surveyData.id), updatedSurvey)
      .then((resp) => {
        toast("Engineer assigned");
        closeModal(resp);
      })
      .catch((err) => {
        console.error("Error assigning engineer:", err);
        toast("Failed to assign engineer");
      });
  };

  return (
    <div className={css.Modal}>
      <div className={css.Body}>
        <h3>Assign Engineer</h3>

        {/* Engineer Dropdown */}
        <AddEngineer onSubmit={onSubmit} />

        {/* Show Selected Engineer */}
        {selectedEngineer && (
          <div className={css.OperationView}>
            <h5>{selectedEngineer.name || selectedEngineer.fullName}</h5>
            <Svg onClick={handleDelete} className={css.Delete}>
              {SvgOptions.Delete}
            </Svg>
          </div>
        )}

        <div className={css.Controls}>
          <Button onClick={Save} className="Btn-Mid Active">
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AssignSurveyEngModal;
